module.exports = __webpack_public_path__ + "static/img/block2_4.f971903.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parkDescription/block2_4.png
// module id = vfei
// module chunks = 1